import * as API from '../../api';
import {MockData} from './mockdata';
import {VehicleType} from './types';
import {numericIdFactory} from '../mocks';
import {getConfig} from '../../config';
import {createEnhancedResourceContainer} from '../utils';

const {
  component: VehicleTypeLoader,
  useOperations: useVehicleTypeOperations,
  useResource: useVehicleType,
  useResources: useVehicleTypes,
} = createEnhancedResourceContainer<
  VehicleType,
  API.Paths.GetVehicleTypes.QueryParameters
>({
  scopeKey: undefined,
  entityName: 'VehicleType',
  idKey: 'id',
  endPoint: '/vehicletypes/v-1',
  mockData: MockData,
  mockIdFactory: numericIdFactory,
  getConfig,
});

export {
  VehicleTypeLoader,
  useVehicleTypeOperations,
  useVehicleType,
  useVehicleTypes,
};
export * from './types';
